// Recipe page helpers: scale quantities, print, keep the screen awake while cooking.
const quantities = document.querySelectorAll('.qty');
const scaleButtons = document.querySelectorAll('[data-scale]');
const scaleNote = document.querySelector('#scale-note');
const formatQuantity = value => {
  const rounded = value >= 10 ? Math.round(value) : Math.round(value * 10) / 10;
  return String(rounded).replace('.', ',');
};

scaleButtons.forEach(button => button.addEventListener('click', () => {
  const factor = Number(button.dataset.scale);
  scaleButtons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
  quantities.forEach(quantity => {
    const low = Number(quantity.dataset.a);
    const high = quantity.dataset.b ? Number(quantity.dataset.b) : null;
    quantity.textContent = factor === 1 ? (high ? `${quantity.dataset.a.replace('.', ',')}–${quantity.dataset.b.replace('.', ',')}` : quantity.dataset.a.replace('.', ',')) : (high ? `${formatQuantity(low * factor)}–${formatQuantity(high * factor)}` : formatQuantity(low * factor));
  });
  scaleNote.hidden = factor === 1;
}));

document.querySelector('#print-recipe')?.addEventListener('click', () => window.print());

const wakeTool = document.querySelector('#wake-tool');
const wakeToggle = document.querySelector('#wake-toggle');
let wakeLock = null;
if (wakeTool && 'wakeLock' in navigator) {
  wakeTool.hidden = false;
  const request = async () => {
    try {
      wakeLock = await navigator.wakeLock.request('screen');
      wakeLock.addEventListener('release', () => { wakeLock = null; });
    } catch {
      wakeToggle.checked = false;
    }
  };
  wakeToggle.addEventListener('change', () => {
    if (wakeToggle.checked) request();
    else wakeLock?.release();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && wakeToggle.checked && !wakeLock) request();
  });
}

document.querySelector('.rt-share')?.addEventListener('click', async () => {
  const data = { title: document.title, url: location.href };
  try {
    if (navigator.share) await navigator.share(data);
    else await navigator.clipboard.writeText(location.href);
  } catch { /* the person closed the share sheet */ }
});
